module.exports = __webpack_public_path__ + "static/img/supplier_tnp_icon.07ed50f8.svg";